export const OPERATION = {
  NONE: 'none',
  CREATE: 'create',
  UPDATE: 'update',
};
